import { render, staticRenderFns } from "./telemedicina_consulta.vue?vue&type=template&id=3f0c069f"
import script from "./telemedicina_consulta.vue?vue&type=script&lang=js"
export * from "./telemedicina_consulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports